import { UtensilsCrossed } from 'lucide-react';
import React from 'react';

import { SingleSheetImportPage } from '@/features/imports/SingleSheetImportPage';

export const ImportMealServicesPage = (): React.JSX.Element => (
  <SingleSheetImportPage
    config={{
      moduleKey: 'meal-service',
      titleSingular: 'meal service',
      titlePlural: 'meal services',
      routePrefix: 'meal-services',
      listPath: '/meal-services',
      ListIcon: UtensilsCrossed,
      invalidateOnSuccess: ['meal-services'],
      summaryFields: ['name', 'city', 'mealKind'],
    }}
  />
);
